// extracted by mini-css-extract-plugin
export var fullWidthButton = "_pv-0";